import React from "react";
import { Field } from "redux-form";

import { Box, Button } from "@braintrust/braintrust-ui-components";
import { CommentTextField } from "@js/apps/common/forms/fields/comment-field";
import { createFormInstance } from "@js/forms/components";
import type { AppDispatch } from "@js/store";

import styles from "./style.module.scss";

const ADD_COMMENT_FORM_ID = "addCommentForm";

type FormData = {
  id: number;
  content: string;
};

type AddCommentFormProps = {
  bidId: number;
  onSubmit: (values: FormData) => Promise<unknown>;
  onSubmitSuccess: (
    _result: unknown,
    _dispatch: AppDispatch,
    props: { reset: () => void },
  ) => void;
};

const AddCommentFormInstance = createFormInstance<FormData, unknown>(
  ADD_COMMENT_FORM_ID,
);

export const AddCommentForm = ({
  bidId,
  onSubmit,
  onSubmitSuccess,
}: AddCommentFormProps) => {
  const initialValues = React.useMemo(() => {
    return {
      id: bidId,
      content: "",
    };
  }, [bidId]);

  return (
    <Box className={styles.form}>
      <AddCommentFormInstance
        form={`${ADD_COMMENT_FORM_ID}-${bidId}`}
        onSubmit={onSubmit}
        onSubmitSuccess={onSubmitSuccess}
        initialValues={initialValues}
      >
        <Field
          id="add-note"
          name="content"
          placeholder="Add a comment..."
          className={styles.field}
          fullWidth
          submitButton={
            <Button
              size="x-small"
              className={styles.formSaveButton}
              variant="transparent-blue"
              type="submit"
            >
              Save
            </Button>
          }
          component={CommentTextField}
        />
      </AddCommentFormInstance>
    </Box>
  );
};
